// extracted by mini-css-extract-plugin
export var pillWrapper = "_qv-0";
export var showOverflow = "_qv-1";